import React, { createContext, useState, useContext, useEffect } from "react";
import { jwtDecode } from "jwt-decode";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isAuthReady, setIsAuthReady] = useState(false); // NEW
  const [user, setUser] = useState({
    token: localStorage.getItem("authToken") || null,
    fullName: localStorage.getItem("fullName") || null,
    barberShop: null,
    barbershopName: null,
    role: null,
  });
  useEffect(() => {
    var token = localStorage.getItem("authToken");
    if (token) {
      const decoded = jwtDecode(token); // Decode JWT token to get user details
      const { exp, barbershop, role, barbershopName } = decoded;
      const currentTime = Date.now() / 1000; // in seconds

      if (
        exp < currentTime ||
        (role != "BarbershopManager" && role != "Staff")
      ) {
        setUser({
          token: null,
          fullName: null,
          barberShop: null,
          role: null,
          barbershopName: null,
        });
        localStorage.removeItem("authToken");
        localStorage.removeItem("fullName");
        setIsAuthenticated(false);
        setIsAuthReady(true);
        logout();
      } else {
        setIsAuthenticated(true);
        setUser({
          token: localStorage.getItem("authToken") || null,
          fullName: localStorage.getItem("fullName") || null,
          barberShop: barbershop,
          barbershopName: barbershopName,
          role: role,
        });
        setIsAuthReady(true);
      }
    } else {
      setIsAuthReady(true);
    }
  }, []);

  // Login function: Decode the token and save user details
  const login = (token) => {
    const decoded = jwtDecode(token); // Decode JWT token to get user details
    const { fullName, barbershop, role, barbershopName } = decoded; // Extract the full name

    // Update state
    setUser({
      token: token,
      fullName: fullName,
      barberShop: barbershop,
      barbershopName: barbershopName,
      role: role,
    });

    setIsAuthenticated(true);
    // Save token and full name to localStorage
    localStorage.setItem("authToken", token);
    localStorage.setItem("fullName", fullName);
  };

  const logout = () => {
    setUser({
      token: null,
      fullName: null,
      barberShop: null,
      role: null,
      barbershopName: null,
    });
    localStorage.removeItem("authToken");
    localStorage.removeItem("fullName");
    setIsAuthenticated(false);
    setIsAuthReady(true);
  };
  return (
    <AuthContext.Provider
      value={{ isAuthenticated, user, isAuthReady, login, logout }}
    >
      {isAuthReady ? children : <div>Loading...</div>}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
